import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "react-select";
import Chip from "@material-ui/core/Chip";

import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-blue-16px.svg";

import {
  CheckActionPermission,
  setPreview as setPreviewAction,
} from "Actions/commonAction";
import { GetMasterData } from "Actions/MasterCodeAction";
import addIcon from "Assets/newicons/action/add-round/outline/add-round-outline-16px.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px.svg";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-16px.svg";
import buIcon from "Assets/newicons/attribute/business-unit/outline/business-unit-outline-16px.svg";
import departmentIcon from "Assets/newicons/attribute/department/outline/department-outline-16px.svg";
import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import globeIcon from "Assets/newicons/services/online-services/outline/online-services-outline-16px.svg";
import activityIcon from "Assets/newicons/user-interface/activity/outline/activity-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import teamIcon from "Assets/newicons/user/team/outline/team-outline-16px.svg";
import employeeIcon from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import menuicon from "Assets/Svg/hamburger-menu-outline-16px.svg";
import emptylist from "Assets/Svg/okr-empty.svg";
import progressIcon from "Assets/Svg/update-progress-outline-16px.svg";
import classNames from "classnames";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import SearchSq from "Component/Material-ui/SearchSq";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import createstore from "store";
import { getFormattedDate, getFormattedImageLink } from "Utils";
import Activity from "./Activity";
import CreateObjective from "./CreateObjective";
import Details from "./Details";
import "./index.scss";
import KeyResult from "./KeyResult";
import Postpone from "./Postpone";

const frequencylist = [
  {
    displayname: "Q1",
    displayvalue: 1,
  },
  {
    displayname: "Q2",
    displayvalue: 2,
  },
  {
    displayname: "Q3",
    displayvalue: 3,
  },
  {
    displayname: "Q4",
    displayvalue: 4,
  },
];

const styles = () => ({
  drawerPaper: {
    width: "40%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
  popOverPaper: {
    width: 140,
    height: 176,
    background: "transparent",
  },
  chip: {
    background: "#dcf2f1",
    color: "#008985",
    height: 20,
  },
  chipKra: {
    background: "#fef1d9",
    color: "#f86b07",
    height: 20,
  },
});

const tempTask = [
  {
    tasktitle: null,
    description: null,
    objectivetaskid: null,
  },
];

class Okrs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      detailsobjectiveid: null,
      tabId: 0,
      WeightageType: [],
      DrawerOpen: false,
      isempty: false,
      isdatavailable: false,
      isMyGoal: true,
      dialogOpen: false,
      editobjective: false,
      viewDetails: false,
      sortmenu: false,
      sort_anchorEl: null,
      isfirstcall: true,
      alignname: "",
      isapicall: false,
      objectiveDetails: false,
      ojective_anchorEl: null,
      updateProgress: false,
      progress_anchorEl: null,
      addobjective: false,
      addobjective_anchorEl: null,
      archivedDetails: false,
      archived_anchorEl: null,
      addperformcycle: false,
      tempobjectivetypeid: null,
      addperformcycle_anchorEl: null,
      open: false,
      searchValue3: null,
      right: false,
      isViewDetails: false,
      isActivity: false,
      selectedRow: null,
      tempobjectivetask: [],
      isCreateObjective: false,
      isKeyResult: false,
      startValue: null,
      selectedobjectivestatusid: null,
      profileimage: null,
      objectivename: "",
      permissions: { editable: true, readonly: true },
      requestreason: "",
      unread: false,
      stepcompleted: "10",
      progressdetail: "50",
      isChildPresent: false,
      expanded: false,
      objectivetypeid: 4,
      successmeasuredid: 1,
      rows: [],
      rows1: [],
      // task: tempTask,
      searchValue: "",
      searchValue1: "",
      offset: 0,
      totalcount: 1,
      limit: 20,
      offset1: 0,
      totalcount1: 1,
      limit1: 20,

      recipient: [],
      empList: [],
      resultobjective: [],
      detailsobjective: [],
      quartercycleid: "",
      ismultiselect: false,
      otherunitid: "",
      keyresulttypeid: "",
      ownerid: "",
      statusid: "",
      mindate: null,
      maxdate: null,
      currencyunicode: null,
      collapsedView: false,
      objectiveid: null,
      objectiveids: null,
      parentobjectiveid: null,
      parentobjectiveids: null,
      originalobjectiveid: null,
      objectivetitle: null,
      description: null,
      measuretypeid: 1,
      taskName: null,
      open1: false,
      objectivedropdownname: "Organization",
      weightagetypeid: 4,
      objectiveunitid: null,
      typeid: null,
      arrayobjectiveid: [],
      performyear: null,
      periodtypeid: null,
      frequencytypeid: null,
      duedate: null,
      isparent: false,
      quatername: null,
      owneremployeeid: null,
      achievetargetvalue: null,
      temppopoverdata: null,
      performcycle: [],
      selectQuarter: false,
      publishtypeid: 1,
      searchObjectiveTitle: null,
      searchObjective: null,
      arremployeedata: [],
      targetvalue: 100,
      dropdownlist: [],
      currenydropdown: [],
      otherdropdown: [],
      activityobjective: [],
      postponeData: [],
      addNewTask: false,
      stackdiv: true,
      selectedobjectiveid: null,
      objectivestatusid: null,
      tempobjectivestatusid: null,
      isobjectivedropdown: false,
      performcycledurationid: null,
      iskeyresult: false,
      selectedtypeid: null,
      selectedempid: null,
      checking: "",
      checking2: "",
      statusCount: [],
      task: [
        {
          objectivetaskid: null,
          tasktitle: null,
          description: null,
        },
      ],
      quartercycle: [
        { displayValue: "1", displayName: "Q1" },
        { displayValue: "1", displayName: "Q1" },
        { displayValue: "1", displayName: "Q1" },
        { displayValue: "1", displayName: "Q1" },
      ],
      otherunits: [{ displayValue: "1", displayName: "Hires" }],
      keyresulttypes: [{ displayValue: "1", displayName: "Individual" }],
      ownerlist: [{ displayValue: "1", displayName: "Individual" }],
      statustypes: [
        { displayvalue: "2", displayname: "On track 🏎" },
        { displayvalue: "1", displayname: "Not begun 💤" },
        { displayvalue: "3", displayname: "Behind 🐢" },
        { displayvalue: "4", displayname: "Done ✅" },
        { displayvalue: "5", displayname: "At risk 💣" },
      ],
      currencylist: [{ displayValue: "1", displayName: "$ USD" }],
      CONTACTS: [
        {
          id: 1,
          title: "Build a new office which can hold 10,000 people and p…",
          type: "Organisation",
          name: "Name",
        },
        {
          id: 2,
          title: "Build a new office which can hold 10,000 people and p…",
          type: "Organisation",
          name: "Name",
        },
      ],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.addkeyresult = this.addkeyresult.bind(this);
    this.setPostPoneData = this.setPostPoneData.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.onSortMenuClick = this.onSortMenuClick.bind(this);
    this.sortMenuClose = this.sortMenuClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.goBack = this.goBack.bind(this);
    this.closePopper = this.closePopper.bind(this);
    this.onObjectiveDetailClick = this.onObjectiveDetailClick.bind(this);
    this.objectiveDetailsClose = this.objectiveDetailsClose.bind(this);

    this.addObjective = this.addObjective.bind(this);
    this.addObjectiveClose = this.addObjectiveClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.editObjective = this.editObjective.bind(this);
    this.searchHandler = this.searchHandler.bind(this);
    this.getOtherData = this.getOtherData.bind(this);
    this.getOkrData = this.getOkrData.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.activityDetails = this.activityDetails.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.setProgressData = this.setProgressData.bind(this);
    this.searchHandler2 = this.searchHandler2.bind(this);
    this.searchHandler1 = this.searchHandler1.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.onAddObjective = this.onAddObjective.bind(this);
    this.selectPerformCycle = this.selectPerformCycle.bind(this);
    this.onSelectQuarter = this.onSelectQuarter.bind(this);
    this.childClick = this.childClick.bind(this);
    this.getOverAllStatus = this.getOverAllStatus.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
    this.GetProfileBasicInfo = this.GetProfileBasicInfo.bind(this);
    this.closePaper = this.closePaper.bind(this);
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "isViewDetails") {
      this.setState({
        isViewDetails: true,
        isActivity: false,
        isCreateObjective: false,
        editobjective: false,
        postPone: false,
        isKeyResult: false,
        updateProgress: false,
        [side]: open,
      });
    } else if (flag === "isActivity") {
      this.setState({
        isViewDetails: false,
        isActivity: true,
        isCreateObjective: false,
        editobjective: false,
        postPone: false,
        isKeyResult: false,
        updateProgress: false,
        [side]: open,
      });
    } else if (flag === "isCreateObjective") {
      this.setState({
        isViewDetails: false,
        isActivity: false,
        isCreateObjective: true,
        editobjective: false,
        postPone: false,
        updateProgress: false,
        isKeyResult: false,
        [side]: open,
      });
    } else if (flag === "isKeyResult") {
      this.setState({
        isViewDetails: false,
        isActivity: false,
        isCreateObjective: false,
        editobjective: false,
        updateProgress: false,
        isKeyResult: true,
        iskeyresult: true,
        postPone: false,
        [side]: open,
      });
    } else if (flag === "postpone") {
      this.setState({
        isViewDetails: false,
        isActivity: false,
        isCreateObjective: false,
        editobjective: false,
        isKeyResult: false,
        postPone: true,
        updateProgress: false,
        [side]: open,
      });
    } else if (flag === "editobjective") {
      this.setState({
        isViewDetails: false,
        isActivity: false,
        isCreateObjective: false,
        isKeyResult: false,
        editobjective: true,
        postPone: false,
        updateProgress: false,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        isViewDetails: false,
        isActivity: false,
        updateProgress: false,
        postPone: false,
        isCreateObjective: false,
        isKeyResult: false,
        [side]: open,
        expanded: false,
        iskeyresult: false,
        searchObjective: null,
        parentobjectiveid: null,
        parentobjectiveids: null,
        originalobjectiveid: null,
        objectiveid: null,
        owneremployeeid: null,
        objectivetitle: null,
        task: [],
        SelectedEmpData: null,
        description: null,
        measuretypeid: 1,
        weightagetypeid: 4,
        // objectivetypeid: null,
        typeid: null,
        performcycledurationid: null,
        periodtypeid: null,
        frequencytypeid: null,
        duedate: null,
        searchValue: null,
        searchValue3: null,
        publishtypeid: 1,
        targetvalue: 100,
        currencyunicode: null,
        objectiveunitid: null,
        objectivestatusid: null,
      });
    }
  };

  setPostPoneData(data) {
    this.setState({
      right: true,
      postPone: true,
      editobjective: false,
      objectiveDetails: false,
      isViewDetails: false,
      isKeyResult: false,
      isActivity: false,
      objectiveid: data.objectiveid,
      objectivetitle: data.objectivetitle,
      frequencytypeid: data.frequencytypeid,
      periodtypeid: data.periodtypeid,
      performcycledurationid: data.performcycledurationid,
    });
  }

  handleClick(value = 0, objectivename) {
    if (value != 0) {
      this.setState(
        {
          objectivetypeid: value,
        },
        () => this.searchHandler(null, false),
      );
    }
    this.setState({
      open: true,
      objectivedropdownname: objectivename,
      resultobjective: [],
      selectedtypeid: null,
      selectedempid: null,
      stackdiv: true,
    });
  }

  handleClose() {
    this.setState({
      dialogOpen: false,
    });
  }

  onSelectCycle(value, year) {
    this.setState({
      selectQuarter: true,
      tempperformcycledurationid: value,
      performyear: year,
    });
  }

  onSelectQuarter(value, name) {
    this.setState({
      selectQuarter: false,
      frequencytypeid: value,
      quatername: name,
    });
  }

  childClick(id, count, objectiveid) {
    // this.setState({ objectiveids: null });
    const parentid = objectiveid;
    if (count != 0) {
      this.state.arrayobjectiveid.push(parentid);
      this.getOkrData(id, false, null);
    }
    this.setState({ backtomain: false });
  }

  addkeyresult(x) {
    this.setState({
      parentobjectiveids: x && x.parentobjectiveids,
      frequencytypeid: x && x.frequencytypeid,
      performcycledurationid: x && x.performcycledurationid,
      periodtypeid: x && x.periodtypeid,
      objectiveunitid: x && x.objectiveunitid,
      measuretypeid: x && x.measuretypeid,
      currencyunicode: x && x.currencyunicode,
      parentobjectiveid: x && x.objectiveid,
      originalobjectiveid: x && (x.originalobjectiveid || x.objectiveid),
      alignname: x && x.objectivetitle,
      isViewDetails: false,
      isActivity: false,
      isCreateObjective: false,
      editobjective: false,
      updateProgress: false,
      isKeyResult: true,
      iskeyresult: true,
      postPone: false,
      checking: x && x.objectivetitle,
      right: true,
    });
  }

  calculateProgress(arrData) {
    const { resultobjective } = this.state;
    arrData.map((x) => {
      if (x.progress && x.progress[0]) {
        // x.progressdetail =
        //   (x.progress[0].achievetargetvalue / x.progress[0].targetvalue) * 100;
        x.progressdetail =
          (x.progress[0] && x.progress[0].achievepercentage) || 0;
      } else {
        x.progressdetail = 0;
      }
      x.keyresult.map((k) => {
        if (k.progress && k.progress[0]) {
          // k.progressdetail =
          //   (k.progress[0].achievetargetvalue / k.progress[0].targetvalue) *
          //   100;
          k.progressdetail =
            (k.progress[0] && k.progress[0].achievepercentage) || 0;
        } else {
          k.progressdetail = 0;
        }
      });
    });
    this.setState({
      resultobjective,
    });
  }

  editObjective(objectiveid) {
    instance.get(`perform/getobjectivebyid/${objectiveid}`).then((resp) => {
      this.setState(
        {
          editobjective: true,
          isKeyResult: false,
          postPone: false,
          objectivetitle:
            resp.data.result[0] && resp.data.result[0].objectivetitle,
          owneremployeeid:
            resp.data.result[0] && resp.data.result[0].owneremployeeid,
          SelectedEmpData: resp.data.result[0]
            ? {
                displayname: resp.data.result[0].employeename || null,
                displayvalue: resp.data.result[0].owneremployeeid || null,
              }
            : null,
          searchValue: this.state.alignobjectivename,
          currencyunicode:
            resp.data.result[0] && resp.data.result[0].currencyunicode,
          description: resp.data.result[0] && resp.data.result[0].description,
          duedate: resp.data.result[0] && resp.data.result[0].duedate,
          employeename: resp.data.result[0] && resp.data.result[0].employeename,
          frequencytypeid:
            resp.data.result[0] && resp.data.result[0].frequencytypeid,
          iskeyresult: resp.data.result[0] && resp.data.result[0].iskeyresult,
          measuretypeid:
            resp.data.result[0] && resp.data.result[0].measuretypeid,
          searchObjective:
            resp.data.result[0] && resp.data.result[0].alignobjectivename,
          objectiveid: resp.data.result[0] && resp.data.result[0].objectiveid,
          objectivestatus:
            resp.data.result[0] && resp.data.result[0].objectivestatus,
          objectivestatusid:
            resp.data.result[0] && resp.data.result[0].objectivestatusid,
          task: resp.data.result[0] && resp.data.result[0].objectivetask,
          objectivetype:
            resp.data.result[0] && resp.data.result[0].objectivetype,
          objectivetypeid:
            resp.data.result[0] && resp.data.result[0].objectivetypeid,
          objectiveunitid:
            resp.data.result[0] && resp.data.result[0].objectiveunitid,
          originalobjectiveid:
            resp.data.result[0] && resp.data.result[0].originalobjectiveid,
          parentobjectiveid:
            resp.data.result[0] && resp.data.result[0].parentobjectiveid,
          parentobjectiveids:
            resp.data.result[0] && resp.data.result[0].parentobjectiveids,
          periodtypeid: resp.data.result[0] && resp.data.result[0].periodtypeid,
          performcycledurationid:
            resp.data.result[0] && resp.data.result[0].performcycledurationid,
          publishtypeid:
            resp.data.result[0] && resp.data.result[0].publishtypeid,
          targetvalue: resp.data.result[0] && resp.data.result[0].targetvalue,
          typeid: resp.data.result[0] && resp.data.result[0].typeid,
          updateddate: resp.data.result[0] && resp.data.result[0].updateddate,
          weightagetypeid:
            resp.data.result[0] && resp.data.result[0].weightagetypeid,
          // isCreateObjective: true,
          right: true,
        },
        () => {
          this.getObjectiveTypeDropDown();
        },
      );
    });
  }

  viewDetails(objectiveid) {
    this.setState({
      isViewDetails: true,
      right: true,
      detailsobjectiveid: objectiveid,
      isActivity: false,
      isCreateObjective: false,
      objectiveDetails: false,
      editobjective: false,
      postPone: false,
      isKeyResult: false,
      updateProgress: false,
    });
  }

  activityDetails(objectiveid) {
    instance
      .get(`perform/getobjectiveactivities/${objectiveid}`)
      .then((resp) => {
        this.setState({
          activityobjective: resp.data.result,
          isActivity: true,
          isViewDetails: false,
          objectiveDetails: false,
          isCreateObjective: false,
          editobjective: false,
          postPone: false,
          isKeyResult: false,
          updateProgress: false,
          right: true,
        });
      });
  }

  goBack() {
    this.setState({ sortmenu: false, open: false, searchValue3: null });
  }

  closePopper() {
    this.setState({ open: false, searchValue3: null });
  }

  sortMenuClose() {
    this.setState({ sortmenu: false, open: false, searchValue3: null });
  }

  onSortMenuClick(event) {
    this.setState({
      sortmenu: !this.state.sortmenu,
      sort_anchorEl: event.currentTarget,
    });
  }

  onObjectiveDetailClick(event, data) {
    this.setState({
      objectiveDetails: !this.state.objectiveDetails,
      ojective_anchorEl: event.currentTarget,
      temppopoverdata: data,
    });
  }

  objectiveDetailsClose() {
    this.setState({ objectiveDetails: false, temppopoverdata: null }, () =>
      this.toggleDrawer("right", false),
    );
  }

  addObjective(event) {
    this.setState({
      addobjective: !this.state.addobjective,
      addobjective_anchorEl: event.currentTarget,
    });
  }

  selectPerformCycle(event) {
    this.setState({
      selectQuarter: false,
      addperformcycle: !this.state.addperformcycle,
      addperformcycle_anchorEl: event.currentTarget,
    });
  }

  addObjectiveClose() {
    this.setState({ addobjective: false });
  }

  handleExpandClick = () => {
    this.setState(
      (state) => ({
        expanded: !state.expanded,
      }),
      this.getOverAllStatus(),
    );
  };

  async componentDidMount() {
    const WeightageType = await GetMasterData("WeightageType");
    const [isTrue, permissions] = CheckActionPermission("okradmin");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getAllEmp();
        this.getPerformCyle();
        this.GetProfileBasicInfo();
        this.setState({ WeightageType: WeightageType.data.result });
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      data = {};
    }
    instance
      .post(URL, data)
      .then((result) => {
        this.setState({ arremployeedata: result.data.result });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  async getOKRDataBDefaultValues() {
    const { performcycle, performcycle1 } = this.state;

    if (performcycle.length == 0) {
      this.props.enqueueSnackbar("Please configure performance cycle", {
        variant: "error",
      });
    }
    const currentyear = new Date().getFullYear();

    const currentDate = moment().format("YYYY-MM-DD");
    // const currentcycle = performcycle.filter(
    //   (x) => x.displayname == currentyear,
    // );
    const currentcycle = performcycle1.filter((x) => x.performcycletypeid == 2);

    this.onSelectCycle(
      currentcycle && currentcycle[0] && currentcycle[0].performcycledurationid,
      currentcycle && currentcycle[0] && currentcycle[0].year,
    );
    const cyclestartdate =
      currentcycle && currentcycle[0] && currentcycle[0].cyclestart;
    let displayname;
    let displayvalue;
    if (
      cyclestartdate <= currentDate &&
      moment(cyclestartdate).add(3, "M").format("YYYY-MM-DD") >= currentDate
    ) {
      displayname = "Q1";
      displayvalue = 1;
    } else if (
      moment(cyclestartdate).add(3, "M").format("YYYY-MM-DD") <= currentDate &&
      moment(cyclestartdate).add(6, "M").format("YYYY-MM-DD") >= currentDate
    ) {
      displayname = "Q2";
      displayvalue = 2;
    } else if (
      moment(cyclestartdate).add(6, "M").format("YYYY-MM-DD") <= currentDate &&
      moment(cyclestartdate).add(9, "M").format("YYYY-MM-DD") >= currentDate
    ) {
      displayname = "Q3";
      displayvalue = 3;
    } else if (
      moment(cyclestartdate).add(9, "M").format("YYYY-MM-DD") <= currentDate &&
      moment(cyclestartdate).add(12, "M").format("YYYY-MM-DD") >= currentDate
    ) {
      displayname = "Q4";
      displayvalue = 4;
    }

    this.getquarter(
      currentcycle && currentcycle[0] && currentcycle[0].cyclestartdate,
      currentcycle && currentcycle[0] && currentcycle[0].cycleenddate,
    );

    // this.handleChange2(displayvalue, displayname);
  }

  getOverAllStatus(id = null) {
    const { isapicall } = this.state;
    if (isapicall == false || id != null) {
      const data = {
        frequencytypeid: this.state.tempfrequencytypeid,
        performcycledurationid: this.state.tempperformcycledurationid,
        owneremployeeid: this.props.login.employeeid,
        objectivestatusid: null,
      };
      this.setState(
        {
          isapicall: true,
          selectedobjectivestatusid: id || null,
        },
        () => {
          instance
            .post("perform/getoverallstatus", data)
            .then((result) => {
              this.setState(
                {
                  statusCount: result.data.result,
                },
                () => id && this.getOkrData(null, true, null, id),
              );
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        },
      );
    }
  }

  SearchEmployee = (search) => {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 0
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: null,
        featurekey: "okradmin",
      };
      instance
        .post(URL, data)
        .then((result) => {
          const arrAllEmp = result.data.result;
          const opt = [];
          opt.push({
            label: "Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 1,
            ),
          });

          opt.push({
            label: "In-Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 3,
            ),
          });

          this.setState({ emplist1: opt });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  getquarter(fromdate, todate) {
    instance
      .get(`subscription/getquater/${fromdate}/${todate}`)
      .then((result) => {
        const quatertypeid = result.data.result[0].quatertypeid;
        const quatername =
          quatertypeid == 1
            ? "Q1"
            : quatertypeid == 2
            ? "Q2"
            : quatertypeid == 3
            ? "Q3"
            : quatertypeid == 4
            ? "Q4"
            : "";
        this.setState(
          {
            quatertypeid,
            quatername,
          },
          () => this.handleChange2(quatertypeid, quatername),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setProgressData(event, data, isparent) {
    instance
      .get(`perform/getobjectiveupdateprogess/${data.objectiveid}`)
      .then((result) => {
        this.setState({
          updateProgress: true,
          isapicall: false,
          ojective_anchorEl: event.currentTarget,
          updateProgressData: result.data.result[0]
            ? result.data.result[0]
            : null,
          isparent,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  openDrawer({ DrawerOpen, type }) {
    this.setState({
      DrawerOpen,
      type: true,
    });
  }

  onAddObjective(option = true) {
    instance
      .get("perform/getokrinit")
      .then((result) => {
        this.setState({
          okrcycle: result.data.result[0].okrcycle.map((x) => {
            const temp = {};
            temp.displayvalue = x.performcycledurationid;
            temp.displayname = x.year;
            return temp;
          }),
          otherdropdown: result.data.result[0].objectiveunit,
          currenydropdown: result.data.result[0].currency,
          WeightageType: result.data.result[0].weightagetype,
          isViewDetails: false,
          isActivity: false,
          isCreateObjective: option,
          editobjective: false,
          postPone: false,
          updateProgress: false,
          isKeyResult: !option,
          right: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updateProgress() {
    const { updateProgressData } = this.state;
    const data = {
      isparentobjective: this.state.isparent,
      objectiveid:
        updateProgressData && this.state.updateProgressData.objectiveid,
      achievetargetvalue:
        updateProgressData && this.state.updateProgressData.achievetargetvalue,
      objectivestatusid:
        updateProgressData && this.state.updateProgressData.objectivestatusid,
      parentobjectiveid:
        updateProgressData && this.state.updateProgressData.parentobjectiveid,
      parentobjectiveids:
        updateProgressData && this.state.updateProgressData.parentobjectiveids,
    };
    if (
      !this.state.isparent &&
      updateProgressData &&
      updateProgressData.achievetargetvalue == null
    ) {
      this.props.enqueueSnackbar("Please enter achieved target", {
        variant: "error",
      });
    } else {
      instance
        .post("perform/objectiveupdate", data)
        .then(() => {
          this.setState(
            {
              updateProgress: false,
              right: false,
              expanded: false,
              updateProgressData: null,
              isparent: false,
            },
            () =>
              this.getOkrData(
                this.props.resultobjective[0]?.objectiveid == undefined
                  ? null
                  : this.props.resultobjective[0].objectiveid,
                false,
                null,
              ),
          );

          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleSearch(e) {
    const { backupList, rows } = this.state;
    const filterList = rows.filter(
      (item) =>
        item.lettername.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      rows: e.target.value ? filterList : backupList,
    });
  }

  searchHandler(event, isobjective = true) {
    const searcjQery = event ? event.target.value.toLowerCase() : null;
    if (searcjQery && searcjQery.length < 4) {
      instance
        .post("perform/getobjectivelist", {
          searchfor: searcjQery,
          objectivetypeid: event ? null : this.state.objectivetypeid,
          // employeeid: this.props.login.employeeid,
          employeeid: null,

          periodtypeid: this.state.periodtypeid,
          frequencytypeid: this.state.tempfrequencytypeid,
          performcycledurationid: this.state.tempperformcycledurationid,
        })
        .then((result) => {
          const ids = result.data.result.map((x) => x.typeid);
          const filtered = result.data.result.filter(
            ({ typeid }, index) => !ids.includes(typeid, index + 1),
          );

          const objfilteredlist =
            filtered &&
            filtered.map((x) => ({
              displayname: x.typename,
              displayvalue: x.displayvalue,
              typename: x.displayname,
              typeid: x.typeid,
            }));

          this.setState({
            dropdownlist: result.data.result,
            filtered,
            objfilteredlist,
            searchValue: searcjQery,
            backupList: result.data.result,
            isobjectivedropdown:
              result.data.result.length != 0 && isobjective ? true : false,
            open: isobjective
              ? false
              : result.data.result.length != 0
              ? true
              : false,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else if (searcjQery == null) {
      instance
        .post("perform/getobjectivelist", {
          searchfor: searcjQery,
          objectivetypeid: event ? null : this.state.objectivetypeid,
          // employeeid: this.props.login.employeeid,
          employeeid: null,
          periodtypeid: this.state.periodtypeid,
          frequencytypeid: this.state.tempfrequencytypeid,
          performcycledurationid: this.state.tempperformcycledurationid,
        })
        .then((result) => {
          const ids = result.data.result.map((x) => x.typeid);
          const filtered = result.data.result.filter(
            ({ typeid }, index) => !ids.includes(typeid, index + 1),
          );

          const objfilteredlist =
            filtered &&
            filtered.map((x) => ({
              displayname: x.typename,
              displayvalue: x.displayvalue,
              typename: x.displayname,
              typeid: x.typeid,
            }));

          this.setState({
            dropdownlist: result.data.result,
            filtered,
            objfilteredlist,
            searchValue: searcjQery,
            open: result.data.result.length != 0 ? true : false,
            backupList: result.data.result,
            resultobjective:
              result.data.result.length != 0 ? this.state.resultobjective : [],
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.setState({
        searchValue: searcjQery,
      });
    }
  }

  searchHandler1(event) {
    const searcjQery = event.target.value.toLowerCase();
    const { backupList } = this.state;

    if (backupList.length != 0) {
      const arrResult = backupList.filter(
        (word) => word.typename.toLowerCase().search(searcjQery) !== -1,
      );
      if (arrResult && arrResult.length != 0) {
        this.setState({
          dropdownlist: arrResult,
          isdatavailable: false,
          searchValue3: searcjQery,
          objectivetypeid: null,
        });
      } else if (searcjQery == "") {
        this.setState({
          dropdownlist: [],
          isdatavailable: true,
          searchValue3: searcjQery,
          objectivetypeid: null,
        });
      } else {
        this.setState({
          isdatavailable: true,
          searchValue3: searcjQery,
          objectivetypeid: null,
        });
      }
    }
  }

  searchHandler2(event) {
    const searcjQery = event.target.value.toLowerCase();
    const { resultobjective, backUpresult } = this.state;

    if (backUpresult.length != 0) {
      const arrResult = backUpresult.filter(
        (word) => word.objectivetitle.toLowerCase().search(searcjQery) !== -1,
      );
      if (arrResult && arrResult.length != 0) {
        this.setState({
          resultobjective: arrResult,
          searchObjectiveTitle: event.target.value,
        });
      } else {
        this.setState({
          searchObjectiveTitle: event.target.value,
          resultobjective: [],
        });
      }
    } else {
      this.setState({
        searchObjectiveTitle: event.target.value,
      });
    }
  }

  getOtherData() {
    instance
      .get("perform/objectiveunitlist")
      .then((result) => {
        this.setState({
          otherdropdown: result.data.result,
          open: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getOkrData(
    objectiveid = null,
    isfirst = true,
    objectivetypeid = this.state.objectivetypeid,
    objectivestatusid = null,
  ) {
    if (objectiveid == null) {
      this.setState({
        task: [],
      });
    }
    const objectiveids1 =
      this.state.dropdownlist &&
      (this.state.objectivetypeid == 1 ||
        this.state.objectivetypeid == 2 ||
        this.state.objectivetypeid == 3)
        ? this.state.dropdownlist.filter(
            (obj) => obj.displayvalue == this.state.selectedtypeid,
          )
        : null;
    const objectiveids =
      this.state.dropdownlist &&
      (this.state.objectivetypeid == 1 ||
        this.state.objectivetypeid == 2 ||
        this.state.objectivetypeid == 3)
        ? this.state.dropdownlist.filter(
            (obj) => obj.typeid == objectiveids1[0].typeid,
          )
        : null;
    const selectedobjectiveids =
      objectiveids &&
      (this.state.objectivetypeid == 1 ||
        this.state.objectivetypeid == 2 ||
        this.state.objectivetypeid == 3)
        ? objectiveids.map((x) => x.displayvalue).join(",")
        : null;
    this.setState({
      loading: true,
      objectiveids1,
      objectiveids,
    });
    const data = {
      // employeeid: isfirst
      //   ? this.props.login.employeeid
      //     ? this.props.login.employeeid
      //     : null
      //   : null,
      employeeid: objectivetypeid == 5 ? this.state.selectedempid : null,
      // objectiveid: objectivetypeid == 4 ? objectiveid : null,
      objectiveid: objectiveid || null,
      objectiveids:
        (objectivetypeid == 1 ||
          objectivetypeid == 2 ||
          objectivetypeid == 3) &&
        selectedobjectiveids
          ? selectedobjectiveids
          : null,
      objectivetypeid: objectivetypeid ? objectivetypeid : null,
      objectivestatusid: objectivestatusid ? objectivestatusid : null,
      periodtypeid: this.state.periodtypeid || null,
      frequencytypeid: this.state.tempfrequencytypeid || null,
      performcycledurationid: this.state.tempperformcycledurationid || null,
    };
    instance
      .post("perform/getobjective", data)
      .then((result) => {
        this.setState(
          {
            resultobjective: result.data.result,
            backUpresult: result.data.result,
            backUpresult1: result.data.result,
            isfirstcall: false,
            right: false,
            open: false,
            searchValue3: null,
            task: [],
            loading: false,
          },
          () => this.calculateProgress(this.state.resultobjective),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getPerformCyle() {
    // const { performcycle } = this.state;
    // if (performcycle.length == 0) {
    //   this.props.enqueueSnackbar("Please configure performance cycle", {
    //     variant: "error",
    //   });
    // }

    instance
      .get("perform/getsubperformcycle")
      .then((result) => {
        this.setState(
          {
            performcycle: result.data.result.map((x) => {
              const temp = {};
              temp.cyclestart = x.cyclestartdate;
              temp.cycleend = x.cycleenddate;
              temp.displayvalue = x.performcycledurationid;
              temp.displayname = x.year;
              return temp;
            }),
            performcycle1: result.data.result,
          },
          () => {
            this.getOKRDataBDefaultValues();
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onDelete({
    objectiveid = null,
    objectivestatusid = null,
    parentobjectiveid = null,
    parentobjectiveids = null,
  }) {
    this.setState({ objectiveDetails: false });
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .post(`perform/deleteobjective`, {
                objectiveid,
                objectivestatusid,
                parentobjectiveid,
                parentobjectiveids,
              })
              .then(
                () => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.setState(
                    {
                      objectiveid: null,
                      iskeyresult: true,
                      parentobjectiveid: null,
                      parentobjectiveids: null,
                      originalobjectiveid: null,
                      objectivetitle: null,
                      description: null,
                      measuretypeid: 1,
                      weightagetypeid: 4,
                      // objectivetypeid: null,
                      tempobjectivetypeid: null,
                      typeid: null,
                      periodtypeid: null,
                      frequencytypeid: null,
                      duedate: null,
                      objectiveDetails: false,
                      owneremployeeid: null,
                      publishtypeid: 1,
                      targetvalue: 100,
                      currencyunicode: null,
                      objectiveunitid: null,
                      objectivestatusid: null,
                      searchValue: null,
                    },
                    () => {
                      this.getOkrData(
                        this.state.resultobjective[0]?.objectiveid == undefined
                          ? null
                          : this.state.resultobjective[0].objectiveid,
                        false,
                        null,
                      );
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() =>
            this.setState({ objectiveDetails: false }, () =>
              this.props.closeSnackbar(),
            )
          }
        >
          No
        </Button>,
      ],
    });
  }

  getObjectiveTypeDropDown() {
    instance
      .get(`perform/getobjectivetypelist/${this.state.objectivetypeid}`)
      .then((result) => {
        this.setState(
          {
            objeciveResult: result.data.result,
          },
          () => this.onAddObjective(),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  closePaper(event) {
    this.setState({
      open: false,
    });
  }

  getAllEmp() {
    const arr = this.props.location.pathname.split("/");
    const { login } = this.props;
    const data = {
      featurekey: "okr",
      subscriptionid: login.subscriptionid,
      statusid: 1,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });
        this.setState(
          {
            empList: result.data.result,
            empList1: opt,
            employeeid: arr && arr[6],
            SelectedEmpData:
              arr &&
              arr[6] &&
              result.data.result.find((x) => x.displayvalue == arr[6])
                ? result.data.result.find((x) => x.displayvalue == arr[6])
                : null,
          },
          () => {
            if (this.props.location.pathname == "/app/pay/payroll/employee") {
              this.props.history.push(
                "/app/pay/payroll/employee/package_proration",
              );
            }
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleChangeProgress(key, value) {
    const { updateProgressData } = this.state;
    updateProgressData[key] = value;
    this.setState({
      updateProgressData,
    });
  }

  handleChange1(key, value) {
    this.setState({ [key]: value }, () =>
      this.getOkrData(value, true, this.state.objectivetypeid),
    );
  }

  GetSelectedEmp(selectedItem) {
    this.setState(
      {
        SelectedEmpData: selectedItem,
        selectedempid: selectedItem ? selectedItem.displayvalue : null,
      },
      () =>
        this.getOkrData(
          selectedItem.displayvalue,
          true,
          this.state.objectivetypeid,
        ),
    );
  }

  handleChange2(value, name) {
    const { isfirstcall } = this.state;
    this.setState(
      {
        quatername: name,
        tempfrequencytypeid: value,
        // selectQuarter: false,
        // addperformcycle: false,
        isapicall: false,
      },
      () => isfirstcall && this.getOkrData(),
    );
  }

  handleClose = () => {
    this.setState({
      open1: false,
    });
  };

  handleOpen = () => {
    this.setState({
      open1: true,
    });
  };

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  render() {
    const { detailsobjective, updateProgress } = this.state;
    const { classes } = this.props;
    const {
      open,
      isViewDetails,
      isActivity,
      isKeyResult,
      isCreateObjective,
      statustypes,
    } = this.state;

    const getStatusCount = (id) => {
      const count =
        this.state.statusCount[0] &&
        this.state.statusCount[0].arrstatuscount.find(
          (x) => x.objectivestatusid == id,
        );
      return count ? count.count : 0;
    };

    return (
      <div className="innerwrapper-full-width">
        <Helmet>
          <title>{headersList.OKRGoals.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div className="content-outer-wrapper">
            <Grid container>
              <Grid item md={6} sm={12} className="position-rel">
                <div className="floatleft">
                  {this.state.objectivetypeid != null ? (
                    <PageHeader header={this.state.objectivedropdownname} />
                  ) : (
                    <PageHeader header="My goals" />
                  )}
                </div>
                <div
                  className="floatleft margin-left-16 margin-right-16 cursor-pointer"
                  onClick={this.onSortMenuClick}
                >
                  <div className="payroll-option">
                    <img src={menuicon}></img>
                    <img src={downArrow} className="margin-left-16"></img>
                  </div>
                  <Popover
                    open={this.state.sortmenu}
                    anchorEl={this.state.sort_anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    onClick={this.closePopper}
                    className="margin-top-8"
                  >
                    <Paper style={{ width: 140 }}>
                      <div>
                        <List>
                          {/* <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() =>
                              this.setState(
                                { objectivedropdownname: "My goals" },
                                () => this.getOkrData(),
                              )
                            }
                          >
                            <ListItemIcon>
                              <img src={userIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                My goals
                              </span>
                            </ListItemText>
                          </ListItem>
                          <Divider /> */}
                          <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() =>
                              this.setState(
                                {
                                  objectivedropdownname: "Organization",
                                  objectivetypeid: 4,
                                  resultobjective: [],
                                  stackdiv: true,
                                  selectedtypeid: null,
                                  selectedempid: null,
                                },
                                () => this.getOkrData(null, true, 4),
                              )
                            }
                          >
                            <ListItemIcon>
                              <img src={globeIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Organization
                              </span>
                            </ListItemText>
                          </ListItem>

                          <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() => this.handleClick(2, "Department")}
                          >
                            <ListItemIcon>
                              <img src={departmentIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Department
                              </span>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() => this.handleClick(3, "Team")}
                          >
                            <ListItemIcon>
                              <img src={teamIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">Team</span>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() => this.handleClick(1, "Business unit")}
                          >
                            <ListItemIcon>
                              <img src={buIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Business unit
                              </span>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            // onClick={() =>
                            //   this.setState(
                            //     {
                            //       objectivedropdownname: "Individual",
                            //       objectivetypeid: 5,
                            //     },
                            //     () => this.getOkrData(null, true, 5),
                            //   )
                            // }
                            onClick={() => this.handleClick(5, "Individual")}
                          >
                            <ListItemIcon>
                              <img src={employeeIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Individual
                              </span>
                            </ListItemText>
                            {/* <ListItemSecondaryAction
                              onClick={() => this.handleClick(5, "Individual")}
                            ></ListItemSecondaryAction> */}
                          </ListItem>
                        </List>
                      </div>
                    </Paper>
                  </Popover>
                </div>
                <div className="floatleft" style={{ width: 210 }}>
                  {this.state.objectivetypeid != 4 && (
                    <div>
                      <div>
                        {this.state.objectivetypeid == 5 ? (
                          // <DynamicForm
                          //   fields={selectinputconverter({
                          //     value: this.state.selectedempid,
                          //     placeholder: "Select employee",
                          //     options: this.state.empList1,
                          //   })}
                          //   onChange={(value) =>
                          //     this.handleChange1("selectedempid", value)
                          //   }
                          // />
                          <Select
                            className="selectsearch inlindClass width250"
                            onChange={this.GetSelectedEmp.bind(this)}
                            onInputChange={this.SearchEmployee}
                            options={this.state.emplist1}
                            getOptionLabel={(option) => option.displayname}
                            getOptionValue={(option) => option.displayvalue}
                            value={this.state.SelectedEmpData}
                            placeholder="Search Employee"
                            isClearable={false}
                          />
                        ) : (
                          <DynamicForm
                            fields={selectinputconverter({
                              value: this.state.selectedtypeid,
                              placeholder:
                                this.state.objectivetypeid == 1
                                  ? "Select business unit"
                                  : this.state.objectivetypeid == 2
                                  ? "Select department"
                                  : this.state.objectivetypeid == 3
                                  ? "Select team"
                                  : "",
                              options: this.state.objfilteredlist,
                            })}
                            onChange={(value) =>
                              this.handleChange1("selectedtypeid", value)
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {/* {open && this.state.dropdownlist.length != 0 && (
                  <ClickAwayListener onClickAway={this.closePaper}>
                    <Paper
                      style={{
                        width: 256,
                        padding: 16,
                        position: "absolute",
                        top: 50,
                        zIndex: 2,
                        boxShadow: "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                        height: 200,
                        overflowY: "auto",
                      }}
                      className="thin-scroll"
                      // onMouseLeave={this.closePaper}
                      // onClick={this.closePaper}
                    >
                      <div
                        className="margin-bottom-16"
                        onChange={() => this.goBack}
                      >
                        <div className="width80 floatleft">
                          <SearchSq
                            placeholder="Search"
                            value={this.state.searchValue3}
                            onChange={this.searchHandler1}
                          />
                        </div>
                        <div className="clear-float"></div>
                      </div>
                      {this.state.isdatavailable && <p>No Data Found</p>}
                      {!this.state.isdatavailable &&
                        this.state.dropdownlist.length != 0 &&
                        this.state.dropdownlist.map((x) => (
                          <div
                            className=" cursor-pointer onShadow"
                            onClick={() =>
                              this.getOkrData(x.displayvalue, false)
                            }
                            style={{
                              borderBottom: "1px solid #d8d8d8",
                              padding: "8px 0px",
                            }}
                          >
                            <p className="normal-dark-secondary margin-bottom-4 margin-left-16 small-dark-secondary">
                              {x.typename}
                            </p>
                            <p className="small-dark-secondary  margin-bottom-4 margin-left-16  width90 eliipsis small-dark-secondary">
                              {x.displayname}
                            </p>
                          </div>
                        ))}
                    </Paper>
                  </ClickAwayListener>
                )} */}
              </Grid>
              <Grid
                item
                md={6}
                sm={12}
                justify="flex-end"
                className="display-flex"
              >
                <div>
                  <div className="floatleft margin-right-16">
                    <SearchSq
                      placeholder="Search Goals"
                      value={this.state.searchObjectiveTitle}
                      onChange={this.searchHandler2}
                    />
                  </div>
                  <div
                    className="floatleft margin-right-16 position-rel "
                    style={{ width: 160, zIndex: 1 }}
                  >
                    <div
                      className="rounded-rectangle-div  "
                      onClick={(event) => this.selectPerformCycle(event)}
                    >
                      {this.state.performyear != null ? (
                        <p className="input-label ">
                          {this.state.performyear} {this.state.quatername}
                        </p>
                      ) : (
                        <p className="input-label ">Select period type</p>
                      )}
                    </div>
                    <Popover
                      open={this.state.addperformcycle}
                      anchorEl={this.state.addperformcycle_anchorEl}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      classes={{
                        paper: classNames(classes.popOverPaper, "no-shadow "),
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      onClose={() =>
                        this.setState({
                          addperformcycle: false,
                          selectQuarter: false,
                        })
                      }
                      className="margin-top-8"
                    >
                      <div>
                        <Paper
                          style={{ width: 72, background: "#f7f8f8" }}
                          className="no-shadow"
                        >
                          <List>
                            {this.state.performcycle.map((x) => (
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onMouseOver={() =>
                                  this.onSelectCycle(
                                    x.displayvalue,
                                    x.displayname,
                                  )
                                }
                              >
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    {x.displayname}
                                  </span>
                                </ListItemText>
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                        {this.state.selectQuarter && (
                          <Paper
                            style={{
                              width: 56,
                              position: "absolute",
                              top: 0,
                              left: 80,
                              boxShadow: "none",
                              zIndex: 1301,
                              background: "#f7f8f8",
                            }}
                          >
                            <div>
                              <List>
                                {frequencylist.map((x) => (
                                  <ListItem
                                    button
                                    className=" padding-top-4 padding-bottom-4 cursor-pointer"
                                    onMouseOver={() =>
                                      this.handleChange2(
                                        x.displayvalue,
                                        x.displayname,
                                      )
                                    }
                                    onClick={() =>
                                      this.setState(
                                        {
                                          selectQuarter: false,
                                          addperformcycle: false,
                                        },
                                        () => this.getOkrData(),
                                      )
                                    }
                                  >
                                    <ListItemText style={{ padding: 0 }}>
                                      <span className="small-dark-secondary">
                                        {x.displayname}
                                      </span>
                                    </ListItemText>
                                  </ListItem>
                                ))}
                              </List>
                            </div>
                          </Paper>
                        )}
                      </div>
                    </Popover>
                  </div>
                  {(this.state.permissions.editable ||
                    this.props.login.masterprofileid == 9) && (
                    <span className="floatleft">
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        onClick={this.onAddObjective}
                      >
                        Add objective
                      </Button>
                    </span>
                  )}

                  <Popover
                    open={this.state.addobjective}
                    anchorEl={this.state.addobjective_anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    onClose={this.addObjectiveClose}
                    className="margin-top-8"
                  ></Popover>
                </div>
              </Grid>
            </Grid>
            {this.state.loading == true ? (
              this.showLoader()
            ) : (
              <div>
                {this.state.isempty ? (
                  <div className="position-rel">
                    <DefaultComp
                      heading={
                        this.state.isMyGoal
                          ? "No goals have been assigned to you yet!"
                          : "No goals have been assigned to Marketing yet!"
                      }
                      subheading="You can create goals by clicking the 'Add objective' button."
                      imageSrc={emptylist}
                    />
                  </div>
                ) : (
                  <div className="okr-main">
                    {(this.state.backtomain ||
                      (this.state.arrayobjectiveid.length == 0 &&
                        !this.state.stackdiv)) && (
                      <div
                        className="display-flex cursor-pointer"
                        style={{ alignItems: "center" }}
                        onClick={() =>
                          this.setState(
                            {
                              stackdiv: true,
                              backtomain: false,
                              // resultobjective: this.state.backUpresult1,
                            },
                            () =>
                              this.getOkrData(
                                null,
                                true,
                                this.state.objectivetypeid,
                                null,
                              ),
                          )
                        }
                      >
                        <img src={backArrow}></img>
                        <p className="normal-blue margin-left-8">Back</p>
                      </div>
                    )}
                    <Grid container>
                      {this.state.resultobjective.length !== 0 ? (
                        this.state.resultobjective.map((x) => (
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sm={12}
                            style={{
                              marginTop: 20,
                            }}
                          >
                            {x && x.alignobjectivename && (
                              <span
                                // onClick={false? this._click: null}
                                onClick={() => {
                                  this.state.arrayobjectiveid.length > 0 &&
                                    x.parentobjectiveid ==
                                      this.state.arrayobjectiveid[
                                        this.state.arrayobjectiveid.length - 1
                                      ] &&
                                    this.state.arrayobjectiveid.pop() &&
                                    this.getOkrData(x.parentobjectiveid, false);
                                }}
                                className={
                                  x.parentobjectiveid ==
                                  this.state.arrayobjectiveid[
                                    this.state.arrayobjectiveid.length - 1
                                  ]
                                    ? "extra-small-dark cursor-pointer"
                                    : "extra-small-dark"
                                }
                                style={{
                                  borderRadius: "4px",
                                  backgroundColor: "#96f7df",
                                  marginLeft: 30,
                                  padding: "4px 8px",
                                  display: "table",
                                }}
                              >
                                {x.alignobjectivename}
                              </span>
                            )}

                            <Paper
                              className="padding16 objective-wrapper"
                              style={{
                                boxShadow: "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                cursor:
                                  x.keyresult.length == 0
                                    ? "default"
                                    : "pointer",
                              }}
                              onClick={() =>
                                this.setState(
                                  x.keyresult.length == 0
                                    ? {}
                                    : {
                                        stackdiv: false,
                                        backtomain: true,
                                        resultobjective:
                                          this.state.resultobjective.filter(
                                            (obj) =>
                                              obj.objectiveid == x.objectiveid,
                                          ),
                                      },
                                )
                              }
                            >
                              <Grid container>
                                <Grid item md={10} sm={12}>
                                  <div
                                    className="display-flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    <Chip
                                      size="small"
                                      label="Objective"
                                      className={classes.chip}
                                    />
                                    <span className="large-text-dark-secondary margin-left-8 width80 t-bold ellipsis display-block">
                                      {x && x.objectivetitle}
                                    </span>
                                  </div>

                                  <div>
                                    <div className="margin-top-16">
                                      <div className="floatleft margin-right-16">
                                        <ProfilePicture
                                          src={getFormattedImageLink(
                                            x && x.imagepath,
                                          )}
                                          height="40"
                                        />
                                      </div>
                                      <div className="floatleft">
                                        <span
                                          className="display-block small-dark-secondary t-bold margin-bottom-8"
                                          style={{ lineHeight: "14px" }}
                                        >
                                          {x && x.employeename}
                                        </span>
                                        <span className="noraml-dark-secondary">
                                          {getFormattedDate(x && x.updateddate)}
                                        </span>
                                      </div>
                                      <div className="clear-left"></div>
                                    </div>
                                    <div className="margin-top-16">
                                      <div
                                        className="floatleft margin-right-32"
                                        style={{
                                          borderRight: "1px solid #d8d8d8",
                                          paddingRight: 32,
                                        }}
                                      >
                                        <p className="display-block small-dark-secondary t-bold">
                                          Period
                                        </p>
                                        <p className="normal-dark-secondary">
                                          Q{x && x.frequencytypeid}{" "}
                                          {x && x.year}
                                        </p>
                                      </div>
                                      <div
                                        className="floatleft margin-right-32"
                                        style={{
                                          borderRight: "1px solid #d8d8d8",
                                          paddingRight: 32,
                                        }}
                                      >
                                        <p className="display-block small-dark-secondary t-bold">
                                          Due on
                                        </p>
                                        <p className="normal-dark-secondary">
                                          {getFormattedDate(x && x.duedate)}
                                          {/* {x.duedate} */}
                                        </p>
                                      </div>
                                      <div
                                        className="floatleft margin-right-32"
                                        style={{
                                          borderRight: "1px solid #d8d8d8",
                                          paddingRight: 32,
                                        }}
                                      >
                                        <p className="display-block small-dark-secondary t-bold">
                                          Type
                                        </p>
                                        <p className="normal-dark-secondary">
                                          {x && x.objectivetype}
                                        </p>
                                      </div>
                                      <div
                                        className="floatleft margin-right-32"
                                        style={{
                                          paddingRight: 16,
                                        }}
                                      >
                                        <div
                                          className="display-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <p className="display-block small-dark-secondary t-bold">
                                            Status
                                          </p>
                                          <Tooltip
                                            title={
                                              <span>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Objective's status is auto
                                                  calculated based on the
                                                  cumulative completion of KRAs.
                                                </p>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  0% is Not begun 💤{" "}
                                                </p>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {" "}
                                                  &#60; 25% is At risk 💣{" "}
                                                </p>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {" "}
                                                  25-49% is Behind 🐢{" "}
                                                </p>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  50-99% is On track 🏎
                                                </p>
                                                <p
                                                  className="extra-small"
                                                  style={{
                                                    color: "#fff",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {" "}
                                                  100% is Done ✅{" "}
                                                </p>
                                              </span>
                                            }
                                            placement="right"
                                          >
                                            <img
                                              src={infoIcon}
                                              style={{
                                                marginLeft: 4,
                                                height: 14,
                                                marginTop: -4,
                                              }}
                                            ></img>
                                          </Tooltip>
                                        </div>
                                        <p className="normal-dark-secondary">
                                          {x && x.objectivestatus}
                                          {x && x.objectivestatusid == 4
                                            ? "✅"
                                            : x && x.objectivestatusid == 3
                                            ? "🐢"
                                            : x && x.objectivestatusid == 6
                                            ? "⏳"
                                            : x && x.objectivestatusid == 2
                                            ? "🏎"
                                            : x && x.objectivestatusid == 5
                                            ? "💣"
                                            : "💤"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                                <Grid item md={2} sm={12}>
                                  <div className="floatleft">
                                    <div
                                      className="progess-wrapper"
                                      style={{
                                        position: "relative",
                                        width: 120,
                                        height: 120,
                                      }}
                                    >
                                      <CircularProgress
                                        className="goal-progress"
                                        variant="static"
                                        value={
                                          x && x.progressdetail > 100
                                            ? 100
                                            : x && x.progressdetail
                                        }
                                      />
                                      <div className="progress-line"></div>
                                      <div
                                        className="vertical-center text-center"
                                        style={{ height: 36 }}
                                      >
                                        <span
                                          style={{
                                            display: "block",
                                            fontSize: 24,
                                            lineHeight: "18px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {x && x.progressdetail}%
                                        </span>
                                        <span className="small-dark-secondary">
                                          Achieved
                                        </span>
                                      </div>
                                    </div>
                                    <div className="margin-top-24">
                                      {/* <p className="normal-blue text-center">View details</p> */}
                                    </div>
                                  </div>
                                  <div className="floatright">
                                    {/* {((this.state.permissions.editable &&
                                      this.props.login.employeeid == x &&
                                      x.owneremployeeid) ||
                                      this.props.login.masterprofileid ==
                                        9) && (
                                      <Tooltip
                                        title="Update Status"
                                        placement="left"
                                      >
                                        <span
                                          className="cursor-pointer"
                                          style={{
                                            height: 30,
                                            width: 30,
                                            borderRadius: 50,
                                            border: "1px solid #d9dadb",
                                            position: "relative",
                                            display: "block",
                                            marginBottom: 12,
                                          }}
                                          onClick={(e) =>
                                            this.setProgressData(e, x, true)
                                          }
                                        >
                                          <img
                                            src={progressIcon}
                                            className="vertical-center"
                                          ></img>
                                        </span>
                                      </Tooltip>
                                    )} */}
                                    {(this.state.permissions.editable ||
                                      this.props.login.masterprofileid ==
                                        9) && (
                                      <Tooltip
                                        title="Add key result"
                                        placement="left"
                                      >
                                        <span
                                          className="cursor-pointer"
                                          style={{
                                            height: 30,
                                            width: 30,
                                            borderRadius: 50,
                                            border: "1px solid #d9dadb",
                                            position: "relative",
                                            display: "block",
                                            marginBottom: 12,
                                          }}
                                          // onClick={() =>
                                          //   this.setState(
                                          //     {
                                          //       parentobjectiveids:
                                          //         x && x.parentobjectiveids,
                                          //       frequencytypeid:
                                          //         x && x.frequencytypeid,
                                          //       performcycledurationid:
                                          //         x && x.performcycledurationid,
                                          //       periodtypeid:
                                          //         x && x.periodtypeid,
                                          //       objectiveunitid:
                                          //         x && x.objectiveunitid,
                                          //       measuretypeid:
                                          //         x && x.measuretypeid,
                                          //       currencyunicode:
                                          //         x && x.currencyunicode,
                                          //       parentobjectiveid:
                                          //         x && x.objectiveid,
                                          //       originalobjectiveid:
                                          //         x &&
                                          //         (x.originalobjectiveid ||
                                          //           x.objectiveid),
                                          //       alignname:
                                          //         x && x.objectivetitle,
                                          //       isViewDetails: false,
                                          //       isActivity: false,
                                          //       isCreateObjective: false,
                                          //       editobjective: false,
                                          //       updateProgress: false,
                                          //       isKeyResult: true,
                                          //       iskeyresult: true,
                                          //       postPone: false,
                                          //       checking: x && x.objectivetitle,
                                          //       right: true,
                                          //     },
                                          //     () => {
                                          //       this.onAddObjective(false);
                                          //     },
                                          //   )
                                          // }
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.addkeyresult(x);
                                            this.onAddObjective(false);
                                          }}
                                        >
                                          <img
                                            src={addIcon}
                                            className="vertical-center"
                                          ></img>
                                        </span>
                                      </Tooltip>
                                    )}
                                    {(this.state.permissions.editable &&
                                      x &&
                                      this.props.login.employeeid ===
                                        x.createdemployeeid) ||
                                    this.props.login.masterprofileid == 9 ? (
                                      <Tooltip title="Edit" placement="left">
                                        <span
                                          className="cursor-pointer"
                                          style={{
                                            height: 30,
                                            width: 30,
                                            borderRadius: 50,
                                            border: "1px solid #d9dadb",
                                            position: "relative",
                                            display: "block",
                                            marginBottom: 12,
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.editObjective(x.objectiveid);
                                          }}
                                        >
                                          <img
                                            src={editIcon}
                                            className="vertical-center"
                                          ></img>
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      ""
                                    )}
                                    <Tooltip
                                      title="View details"
                                      placement="left"
                                    >
                                      <span
                                        className="cursor-pointer"
                                        style={{
                                          height: 30,
                                          width: 30,
                                          borderRadius: 50,
                                          border: "1px solid #d9dadb",
                                          position: "relative",
                                          display: "block",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.onObjectiveDetailClick(e, x);
                                        }}
                                      >
                                        <img
                                          src={kebabIcon}
                                          className="vertical-center"
                                        ></img>
                                      </span>
                                    </Tooltip>
                                  </div>
                                </Grid>
                              </Grid>
                            </Paper>
                            {x.keyresult.length !== 0 && this.state.stackdiv && (
                              <div className="stack-div">
                                <Paper
                                  style={{
                                    height: 8,
                                    margin: "0 auto",
                                    width: "90%",
                                    boxShadow:
                                      "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
                                    border: "1px solid #ddd",
                                  }}
                                ></Paper>
                                <Paper
                                  style={{
                                    height: 6,
                                    margin: "0 auto",
                                    width: "88%",
                                    zIndex: -1,
                                    boxShadow:
                                      "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
                                    border: "1px solid #ddd",
                                    position: "relative",
                                    top: -1,
                                  }}
                                ></Paper>
                              </div>
                            )}
                            {!this.state.stackdiv && (
                              <div>
                                {x &&
                                  x.keyresult.length !== 0 &&
                                  x.keyresult.map((x1) => (
                                    <div
                                      onClick={() =>
                                        this.childClick(
                                          x1.objectiveid,
                                          x1.count,
                                          x1.parentobjectiveid,
                                        )
                                      }
                                    >
                                      <span
                                        className="floatleft"
                                        style={{ fontSize: 24 }}
                                      >
                                        🎯
                                      </span>
                                      <Paper
                                        className={
                                          x1.count != 0
                                            ? "padding16 cursor-pointer"
                                            : "padding16"
                                        }
                                        style={{
                                          boxShadow:
                                            "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                          width: "90%",
                                          margin: "24px auto 0px",
                                        }}
                                      >
                                        <Grid container>
                                          <Grid item md={10} sm={12}>
                                            <div
                                              className="display-flex"
                                              style={{ alignItems: "center" }}
                                            >
                                              <Chip
                                                size="small"
                                                label={
                                                  x1.iskeyresult
                                                    ? "Key Result"
                                                    : "Objective"
                                                }
                                                className={
                                                  x1.iskeyresult
                                                    ? classes.chipKra
                                                    : classes.chip
                                                }
                                              />
                                              <span className="large-text-dark-secondary margin-left-8 width100 t-bold ellipsis display-block">
                                                {x1.objectivetitle}
                                              </span>
                                            </div>

                                            <div>
                                              <div
                                                className="margin-top-32"
                                                style={{ display: "flex" }}
                                              >
                                                <div
                                                  className="floatleft margin-right-32"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d8d8d8",
                                                    paddingRight: 32,
                                                  }}
                                                >
                                                  <p className="display-block small-dark-secondary t-bold">
                                                    Owner
                                                  </p>
                                                  <p className="normal-dark-secondary ">
                                                    {x1.employeename}
                                                  </p>
                                                </div>
                                                <div
                                                  className="floatleft margin-right-32"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d8d8d8",
                                                    paddingRight: 32,
                                                  }}
                                                >
                                                  <p className="display-block small-dark-secondary t-bold">
                                                    Period
                                                  </p>
                                                  <p className="normal-dark-secondary">
                                                    Q{x1.frequencytypeid}{" "}
                                                    {x1.year}
                                                  </p>
                                                </div>
                                                <div
                                                  className="floatleft margin-right-32"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d8d8d8",
                                                    paddingRight: 32,
                                                  }}
                                                >
                                                  <p className="display-block small-dark-secondary t-bold">
                                                    Due on
                                                  </p>
                                                  <p className="normal-dark-secondary">
                                                    {getFormattedDate(
                                                      x1.duedate,
                                                    )}
                                                  </p>
                                                </div>
                                                <div
                                                  className="floatleft margin-right-32 width30"
                                                  style={{
                                                    paddingRight: 16,
                                                  }}
                                                >
                                                  <p className="floatleft small-dark-secondary t-bold">
                                                    {x1.progressdetail}%
                                                  </p>
                                                  <p className="floatright normal-dark-secondary">
                                                    {x1.objectivestatus}
                                                    {x1.objectivestatusid == 4
                                                      ? "✅"
                                                      : x1.objectivestatusid ==
                                                        3
                                                      ? "🐢"
                                                      : x1.objectivestatusid ==
                                                        6
                                                      ? "⏳"
                                                      : x1.objectivestatusid ==
                                                        2
                                                      ? "🏎"
                                                      : x1.objectivestatusid ==
                                                        5
                                                      ? "💣"
                                                      : "💤"}
                                                  </p>
                                                  <div className="clear-float"></div>
                                                  <div
                                                    className="floatleft margin-right-8 "
                                                    style={{ width: "75%" }}
                                                  >
                                                    <LinearProgress
                                                      variant="determinate"
                                                      value={
                                                        x1.progressdetail > 100
                                                          ? 100
                                                          : x1.progressdetail
                                                      }
                                                      className="margin-top-12  "
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </Grid>
                                          <Grid item md={2} sm={12}>
                                            <div className="floatright">
                                              {!x1.iskeyresult && (
                                                <Tooltip
                                                  title="Add key result"
                                                  placement="left"
                                                >
                                                  <span
                                                    className="cursor-pointer"
                                                    style={{
                                                      height: 30,
                                                      width: 30,
                                                      borderRadius: 50,
                                                      border:
                                                        "1px solid #d9dadb",
                                                      position: "relative",
                                                      display: "block",
                                                      marginBottom: 12,
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.addkeyresult(x1);
                                                      this.onAddObjective(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={addIcon}
                                                      className="vertical-center"
                                                    ></img>
                                                  </span>
                                                </Tooltip>
                                              )}
                                              {!x1.iskeyresult && (
                                                <Tooltip
                                                  title="Edit"
                                                  placement="left"
                                                >
                                                  <span
                                                    className="cursor-pointer"
                                                    style={{
                                                      height: 30,
                                                      width: 30,
                                                      borderRadius: 50,
                                                      border:
                                                        "1px solid #d9dadb",
                                                      position: "relative",
                                                      display: "block",
                                                      marginBottom: 12,
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.editObjective(
                                                        x1.objectiveid,
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={editIcon}
                                                      className="vertical-center"
                                                    ></img>
                                                  </span>
                                                </Tooltip>
                                              )}
                                              <Tooltip
                                                title="View details"
                                                placement="left"
                                              >
                                                <span
                                                  className="cursor-pointer"
                                                  style={{
                                                    height: 30,
                                                    width: 30,
                                                    borderRadius: 50,
                                                    border: "1px solid #d9dadb",
                                                    position: "relative",
                                                    display: "block",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.onObjectiveDetailClick(
                                                      e,
                                                      x1,
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={kebabIcon}
                                                    className="vertical-center"
                                                  ></img>
                                                </span>
                                              </Tooltip>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Paper>

                                      {x1.count != 0 && (
                                        <div className="stack-div">
                                          <Paper
                                            style={{
                                              height: 8,
                                              margin: "0 auto",
                                              width: "90%",
                                              boxShadow:
                                                "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
                                              border: "1px solid #ddd",
                                            }}
                                          ></Paper>
                                          <Paper
                                            style={{
                                              height: 6,
                                              margin: "0 auto",
                                              width: "88%",
                                              zIndex: -1,
                                              boxShadow:
                                                "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
                                              border: "1px solid #ddd",
                                              position: "relative",
                                              top: -1,
                                            }}
                                          ></Paper>
                                        </div>
                                      )}
                                    </div>
                                  ))}
                              </div>
                            )}
                          </Grid>
                        ))
                      ) : (
                        <div className="content-outer-wrapper">
                          <div className="position-rel">
                            <DefaultComp
                              heading={
                                this.state.objectivetypeid == 1
                                  ? "No goals have been assigned to business unit yet!"
                                  : this.state.objectivetypeid == 2
                                  ? "No goals have been assigned to department yet!"
                                  : this.state.objectivetypeid == 3
                                  ? "No goals have been assigned to team yet!"
                                  : this.state.objectivetypeid == 5
                                  ? "No goals have been assigned to employee yet!"
                                  : this.state.objectivetypeid == 4
                                  ? "No goals have been assigned to organization yet!"
                                  : ""
                              }
                              subheading="You can create goals by clicking the 'Add objective' button."
                              imageSrc={emptylist}
                            />
                          </div>
                        </div>
                      )}

                      <Popover
                        open={this.state.objectiveDetails}
                        anchorEl={this.state.ojective_anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        onClose={this.objectiveDetailsClose}
                        className="margin-top-8"
                      >
                        <Paper style={{ width: 180 }}>
                          <div>
                            <List>
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={() =>
                                  this.viewDetails(
                                    this.state.temppopoverdata.objectiveid,
                                  )
                                }
                              >
                                <ListItemIcon>
                                  <img src={infoIcon}></img>
                                </ListItemIcon>
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Details
                                  </span>
                                </ListItemText>
                              </ListItem>
                              <ListItem
                                button
                                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                onClick={() =>
                                  this.activityDetails(
                                    this.state.temppopoverdata.objectiveid,
                                  )
                                }
                              >
                                <ListItemIcon>
                                  <img src={activityIcon}></img>
                                </ListItemIcon>
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Activity
                                  </span>
                                </ListItemText>
                              </ListItem>
                              {/* <ListItem
                            button
                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                            onClick={() =>
                              this.setPostPoneData(this.state.temppopoverdata)
                            }
                          >
                            <ListItemIcon>
                              <img src={timeIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Postpone
                            </span>
                            </ListItemText>
                          </ListItem> */}
                              {(this.state.permissions.editable &&
                                this.state.temppopoverdata &&
                                this.props.login.employeeid ===
                                  this.state.temppopoverdata
                                    .createdemployeeid) ||
                              this.props.login.masterprofileid == 9 ? (
                                <ListItem
                                  button
                                  className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                  onClick={() =>
                                    this.onDelete(this.state.temppopoverdata)
                                  }
                                >
                                  <ListItemIcon>
                                    <img src={deleteIcon}></img>
                                  </ListItemIcon>
                                  <ListItemText style={{ padding: 0 }}>
                                    <span className="small-dark-secondary">
                                      Delete
                                    </span>
                                  </ListItemText>
                                </ListItem>
                              ) : (
                                ""
                              )}
                            </List>
                          </div>
                        </Paper>
                      </Popover>
                    </Grid>
                  </div>
                )}
              </div>
            )}

            <Drawer
              anchor="right"
              open={this.state.right}
              onClose={this.toggleDrawer("right", false)}
              classes={{
                paper: `${
                  isViewDetails ? "width40" : "width30"
                } planner-drawer padding15`,
              }}
            >
              <DrawerHeader
                header={
                  isViewDetails
                    ? "Details"
                    : isActivity
                    ? "Activities"
                    : isCreateObjective && this.state.objectiveid == null
                    ? "Add Objective"
                    : isCreateObjective && this.state.objectiveid != null
                    ? "Edit Objective"
                    : isKeyResult
                    ? "Add key result"
                    : this.state.postPone
                    ? "Postpone"
                    : ""
                }
                isbackarrow={false}
                closeDrawer={this.toggleDrawer("right", false)}
              />
              {isViewDetails && (
                <Details
                  isViewDetails={isViewDetails}
                  detailsobjectiveid={this.state.detailsobjectiveid}
                  getData={this.getData}
                  handleChange1={this.handleChange1}
                  adddetailsTask={this.adddetailsTask}
                  toggleDrawer={this.toggleDrawer}
                  permissions={this.state.permissions}
                />
              )}
              {isActivity && (
                <Activity
                  activityobjective={this.state.activityobjective}
                  toggleDrawer={this.toggleDrawer}
                  {...this.state}
                />
              )}
              {this.state.postPone && (
                <Postpone
                  detailsobjective={detailsobjective}
                  handleChange1={this.handleChange1}
                  getOkrData={this.getOkrData}
                  toggleDrawer={this.toggleDrawer}
                  {...this.state}
                />
              )}
              {isKeyResult && (
                <KeyResult
                  getOkrData={this.getOkrData}
                  {...this.state}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer}
                />
              )}
              {isCreateObjective && (
                <CreateObjective
                  {...this.state}
                  getOkrData={this.getOkrData}
                  toggleDrawer={this.toggleDrawer}
                />
              )}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Okrs)));
